import { render, staticRenderFns } from "./PatDossierTab.vue?vue&type=template&id=d14b6f22"
import script from "./PatDossierTab.vue?vue&type=script&lang=js"
export * from "./PatDossierTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports